/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sort-imports */
/* eslint-disable import/order */
/* eslint-disable import/no-unresolved */
import { FunctionComponent, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from 'src/hooks';
import { getDocumentList, UserSelectors } from 'src/reducers/user';
import { Card, DashboardWrapper, Footer, Text, AIDialog, PlatformTitle } from 'src/shared';
import { Size } from 'src/shared/text';
import { ContentView, ResponsiveContentContainer, PDFContainer, PDBContainer, BackButton, HeaderTitle, HeaderDescription, GalleryHeader, MainContentContainer, CarouselWrapper, AIDialogWrapper } from './styles';
import { Col, Row } from 'react-bootstrap';
import { Worker } from '@react-pdf-viewer/core';
import { Colors } from 'src/utils/color';
import '@react-pdf-viewer/thumbnail/lib/styles/index.css';
import ThumbnailRender from './documentComponents/thumbnailView';
import ModalView from './documentComponents/modalView';
import PDBViewer from './documentComponents/pdbView';
import { getAuthToken } from 'src/utils/auth';

type Props = Record<string, never>;

const Drug: FunctionComponent<Props> = ({}: Props) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { profile } = UserSelectors();
    const isLoggedIn = Boolean(getAuthToken() && profile);
    const numDocsRender = 6; // how many documents to query and render from backend
    const [listDocs, setListDocs] = useState<Array<Array<string>>>();
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        dispatch(getDocumentList({ numDocs: numDocsRender })).then(
            (response) => {
                let data_tuples = response?.payload?.data?.data_tuples;
                setListDocs(data_tuples);
            }
        );
    }, [dispatch]);

    const nextSlide = () => {
        if (listDocs) {
            setCurrentIndex((prevIndex) => 
                prevIndex === listDocs.length - 1 ? 0 : prevIndex + 1
            );
        }
    };

    const prevSlide = () => {
        if (listDocs) {
            setCurrentIndex((prevIndex) => 
                prevIndex === 0 ? listDocs.length - 1 : prevIndex - 1
            );
        }
    };

    const goToSlide = (index: number) => {
        setCurrentIndex(index);
    };



    if (!listDocs || listDocs.length === 0) {
        return (
            <DashboardWrapper>
                <ContentView>
                    <Card
                        backgroundColor={Colors.theme.secondary}
                        height="400px"
                        width="100%"
                        className="loading-view"
                    >
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            height: '100%',
                            fontSize: '18px',
                            color: '#666'
                        }}>
                            Loading documents...
                        </div>
                    </Card>
                </ContentView>
            </DashboardWrapper>
        );
    }

    return (
        <DashboardWrapper>
            <ContentView>
                <PlatformTitle
                    title="Drug Discovery Platform"
                    description="Explore FDA documents with 3D molecular models and AI-powered insights"
                />

                {/* Main Content Container - Split Layout (Responsive) */}
                <MainContentContainer>
                    {/* Left Side - Gallery Container */}
                    <CarouselWrapper>
                    {/* Navigation Buttons */}
                    <button
                        onClick={prevSlide}
                        style={{
                            position: 'absolute',
                            left: '20px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            border: 'none',
                            background: 'rgba(255, 255, 255, 0.9)',
                            color: '#333',
                            fontSize: '24px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            zIndex: 10,
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 1)';
                            e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.9)';
                            e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                        }}
                    >
                        ‹
                    </button>

                    <button
                        onClick={nextSlide}
                        style={{
                            position: 'absolute',
                            right: '20px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            border: 'none',
                            background: 'rgba(255, 255, 255, 0.9)',
                            color: '#333',
                            fontSize: '24px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            zIndex: 10,
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 1)';
                            e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.9)';
                            e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                        }}
                    >
                        ›
                    </button>

                    {/* Carousel Items */}
                    <div style={{
                        position: 'relative',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        {listDocs.map((element, index) => {
                            const isActive = index === currentIndex;
                            const isLeft = index === currentIndex - 1 || (currentIndex === 0 && index === listDocs.length - 1);
                            const isRight = index === currentIndex + 1 || (currentIndex === listDocs.length - 1 && index === 0);
                            
                            let transform = '';
                            let width = '60%';
                            let height = '70%';
                            let opacity = 0.3;
                            let zIndex = 1;

                            if (isActive) {
                                transform = 'translateX(0) scale(1)';
                                width = '80%';
                                height = '90%';
                                opacity = 1;
                                zIndex = 3;
                            } else if (isLeft) {
                                transform = 'translateX(-120%) scale(0.8)';
                                opacity = 0.7;
                                zIndex = 2;
                            } else if (isRight) {
                                transform = 'translateX(120%) scale(0.8)';
                                opacity = 0.7;
                                zIndex = 2;
                            } else {
                                transform = 'translateX(0) scale(0.6)';
                            }

                            const uniqueKey = `carousel-${index}-${element[0]}-${element[1]}`;

                            return (
                                <div
                                    key={uniqueKey}
                                    onClick={() => goToSlide(index)}
                                    style={{
                                        position: 'absolute',
                                        width,
                                        height,
                                        transform,
                                        transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                                        cursor: 'pointer',
                                        zIndex,
                                        opacity
                                    }}
                                >
                                    <div style={{
                                        width: '100%',
                                        height: '100%',
                                        background: 'white',
                                        borderRadius: '12px',
                                        boxShadow: isActive 
                                            ? '0 20px 40px rgba(0, 0, 0, 0.15)' 
                                            : '0 8px 24px rgba(0, 0, 0, 0.1)',
                                        overflow: 'hidden',
                                        transition: 'all 0.3s ease',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        padding: '20px'
                                    }}>
                                        <Worker
                                            key={`worker-${uniqueKey}`}
                                            workerUrl={
                                                'https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js'
                                            }
                                        >
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                height: '100%',
                                                gap: '8px'
                                            }}>
                                                                                                 {/* Main Content - Responsive Layout */}
                                                 <ResponsiveContentContainer>
                                                     {/* PDF Thumbnail and Modal - Top on mobile, Left on desktop */}
                                                     <PDFContainer key={`pdf-${uniqueKey}`} isActive={isActive}>
                                                         <ThumbnailRender key={`thumbnail-${uniqueKey}`} fileUrl={element[0]} />
                                                         <ModalView key={`modal-${uniqueKey}`} fileUrl={element[0]} title={element[1]} />
                                                     </PDFContainer>
                                                     
                                                     {/* 3D Model - Bottom on mobile, Right on desktop */}
                                                     <PDBContainer key={`pdb-${uniqueKey}`}>
                                                         <PDBViewer key={`pdbviewer-${uniqueKey}`} pdbUrl={element[5]} />
                                                     </PDBContainer>
                                                 </ResponsiveContentContainer>
                                                
                                                {/* Document Info - Below the main content */}
                                                <div key={`info-${uniqueKey}`} style={{
                                                    flex: '0 0 auto',
                                                    textAlign: 'center',
                                                    padding: '8px',
                                                    background: isActive ? '#f8f9fa' : '#f1f3f4',
                                                    borderRadius: '8px',
                                                    transition: 'all 0.3s ease'
                                                }}>
                                                    <Text
                                                        fontSize={isActive ? Size.XSmall : Size.XXXSmall}
                                                        lineHeight={'16px'}
                                                        fontWeight="400"
                                                        textAlign="center"
                                                        fontFamily="Inter"
                                                        marginBottom={0}
                                                        color={isActive ? '#333' : '#666'}
                                                    >
                                                        {element[2]}
                                                    </Text>
                                                    <Text
                                                        fontSize={isActive ? Size.Small : Size.XSmall}
                                                        lineHeight={'20px'}
                                                        fontWeight="600"
                                                        textAlign="center"
                                                        fontFamily="Inter"
                                                        marginBottom={0}
                                                        color={isActive ? '#2c3e50' : '#7f8c8d'}
                                                    >
                                                        {`Gene Symbol: ${element[4]}`}
                                                    </Text>
                                                    <Text
                                                        fontSize={isActive ? Size.Small : Size.XSmall}
                                                        lineHeight={'20px'}
                                                        fontWeight="600"
                                                        textAlign="center"
                                                        fontFamily="Inter"
                                                        marginBottom={0}
                                                        color={isActive ? '#2c3e50' : '#7f8c8d'}
                                                    >
                                                        {`Gene Name: ${element[3]}`}
                                                    </Text>
                                                </div>
                                            </div>
                                        </Worker>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    </CarouselWrapper>

                    {/* Right Side - AI Dialog Interface */}
                    <AIDialogWrapper>
                        <AIDialog
                            isLoggedIn={isLoggedIn}
                            title="AI Drug Discovery Assistant"
                            subtitle="Ask me about drug discovery insights"
                            placeholder="Ask about drug discovery insights..."
                            width="100%"
                        />
                    </AIDialogWrapper>
                </MainContentContainer>

                {/* Dots Indicator */}
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    gap: '8px', 
                    marginTop: '20px' 
                }}>
                    {listDocs.map((_, index) => (
                        <button
                            key={`dot-${index}-${listDocs[index]?.[0] || 'unknown'}`}
                            onClick={() => goToSlide(index)}
                            style={{
                                width: '12px',
                                height: '12px',
                                borderRadius: '50%',
                                border: 'none',
                                backgroundColor: index === currentIndex ? '#3498db' : '#bdc3c7',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease'
                            }}
                            aria-label={`Go to document ${index + 1}`}
                        />
                    ))}
                </div>

                {/* Instructions */}
                <div style={{
                    textAlign: 'center',
                    marginTop: '20px',
                    padding: '15px',
                    background: '#f8f9fa',
                    borderRadius: '8px',
                    color: '#666',
                    fontSize: '14px'
                }}>
                    <p style={{ margin: 0 }}>
                        💡 <strong>Tip:</strong> Use the arrow buttons, click on documents, or use arrow keys to navigate
                    </p>
                </div>
            </ContentView>
            
            {/* Footer with version information */}
            <Footer />
        </DashboardWrapper>
    );
};

export default Drug;
